import {
  AutocompleteArrayInput,
  AutocompleteInput,
  BooleanField,
  BooleanInput,
  CreateButton,
  DataTable,
  EditButton,
  FilterButton,
  FunctionField,
  List,
  ReferenceArrayInput,
  ReferenceInput,
  SearchInput,
  SelectArrayInput,
  SelectField,
  TopToolbar,
} from "react-admin";
import {
  DISCOUNT_COUPON_APPLIES_TO_CHOICES,
  DISCOUNT_COUPON_TYPE_CHOICES,
} from "../utils/DiscountCouponUtil";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";
import { ROLE_TYPES } from "../enums/Roles";
import DynamicReferenceField from "./DynamicReferenceField";
import DiscountValueField from "./DiscountValueField";

const DiscountCouponFilter = () => {
  return [
    <SearchInput source="code" alwaysOn placeholder="Buscar por Código" />,
    <SelectArrayInput
      label="Tipo"
      source="type"
      choices={DISCOUNT_COUPON_TYPE_CHOICES}
    />,
    <ReferenceArrayInput
      source="restaurants"
      reference="restaurants"
      perPage={100}
      filter={{
        active: true,
        type: RESTAURANT_TYPES.ALL,
      }}
      label="Restaurante(s)"
    >
      <AutocompleteArrayInput
        filterToQuery={(searchText) => ({
          name: searchText,
          type: RESTAURANT_TYPES.ALL,
        })}
        label="Restaurante(s)"
        optionText="name"
      />
    </ReferenceArrayInput>,
    <ReferenceInput
      source="products"
      reference="products"
      perPage={100}
      filter={{
        active: true,
      }}
      label="Producto(s)"
    >
      <AutocompleteArrayInput
        filterToQuery={(searchText) => ({ name: searchText })}
        label="Producto(s)"
        optionText="name"
      />
    </ReferenceInput>,
    <ReferenceArrayInput
      source="placeTypes"
      reference="place-types"
      perPage={100}
      filter={{
        active: true,
      }}
      label="Tipo de lugar(es)"
    >
      <AutocompleteArrayInput
        filterToQuery={(searchText) => ({
          name: searchText,
          active: true,
        })}
        label="Tipo de lugar(es)"
        optionText="name"
      />
    </ReferenceArrayInput>,
    <ReferenceInput
      source="user"
      reference="users"
      filter={{
        active: true,
        role: ROLE_TYPES.CUSTOMER,
      }}
      label="Usuario"
    >
      <AutocompleteInput
        filterToQuery={(searchText) => ({ email: searchText })}
        label="Usuario"
        optionText="email"
      />
    </ReferenceInput>,
    <BooleanInput label="Activo" source="active" />,
  ];
};

const DiscountCouponListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const DiscountCouponList = () => (
  <List
    title="Cupones"
    exporter={false}
    actions={<DiscountCouponListActions />}
    filters={DiscountCouponFilter()}
  >
    <DataTable rowClick="show" bulkActionButtons={false}>
      <DataTable.Col source="title" label="Título" />
      <DataTable.Col source="code" label="Código" />
      <DataTable.Col source="discount" label="Descuento">
        <DiscountValueField source="discount" label="Descuento" />
      </DataTable.Col>
      <DataTable.Col source="type" label="Audiencia">
        <SelectField
          source="type"
          label="Audiencia"
          choices={DISCOUNT_COUPON_TYPE_CHOICES}
        />
      </DataTable.Col>
      <DataTable.Col source="appliesTo.type" label="Aplica a">
        <SelectField
          source="appliesTo.type"
          label="Aplica a"
          choices={DISCOUNT_COUPON_APPLIES_TO_CHOICES}
        />
      </DataTable.Col>
      <DataTable.Col label="Entidades">
        <FunctionField
          label="Entidades"
          render={(record) => <DynamicReferenceField record={record} />}
        />
      </DataTable.Col>
      <DataTable.Col source="active" label="Activo">
        <BooleanField source="active" label="Activo" />
      </DataTable.Col>
      <DataTable.Col>
        <EditButton />
      </DataTable.Col>
    </DataTable>
  </List>
);

export default DiscountCouponList;
